module.exports = __webpack_public_path__ + "static/media/lotte_dutch.8bcf9788.mp3";